var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{class:['headline', 'font-grey', 'font-l-600'],domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('div',{class:['server-side-description'],domProps:{"innerHTML":_vm._s(_vm.description)}}),_vm._v(" "),_c('category-list',{attrs:{"type":"getting-started","sort":false}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8d02404","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/top-level-getting-started.vue
// module id = null
// module chunks = 